import { Component } from '@angular/core';
import { OrderService } from '../../../models/orders/orderService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilters } from '../../../models/search/searchFilters';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { OrdersPopupComponent } from '../orders-popup/orders-popup.component';

@Component({
  selector: 'app-orders-table-view',
  standalone: false,
  templateUrl: './orders-table-view.component.html',
})
export class OrdersTableViewComponent extends TableViewAbstractComponent {

  loading = true;
  constructor(
    private orderService: OrderService,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
  ) {
    super();
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<OrderDetails>> {
    return this.orderService
      .getPaged(query, {
        pageNum: pageNum,
        pageSize: pageSize,
        orderBy: 'create_date',
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        userId: this.options.userId ? this.options.userId : '',
        restrictToAction: this.options.restrictToAction,
        //allowRefund: this.options.allowRefund,
        merchantId: this.options.merchantId ? this.options.merchantId : '',
        customerId: this.options.customerId ? this.options.customerId : '',
        month: this.options.month ? this.options.month : '',
        year: this.options.year ? this.options.year : '',
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<OrderDetails>({});
      }).finally(() => this.loading = false);
  }

  getRecordFromDataSource(orderId: string): OrderDetails {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == orderId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Order not found in dataset';
  }

  canQuery(): boolean {
    if (this.options) {
      return (
        (this.options && this.options.merchantId != undefined) ||
        this.options.customerId != undefined ||
        this.options.userId != undefined
      );
    }
    return false;
  }

  onRowClick(row: any) {
    this.dialog.open(OrdersPopupComponent, {
      data: {
        orderId: row.id,
        invoiceNumber: row.invoiceNumber,
        merchantId: row.merchantId,
        customerName: row.customerFirst + ' ' + row.customerLast,
        merchantName: row.merchantName,
        transactionsCount: row.transactions,
      },
    });
  }
}
